export default function Rolunk() {
  return (
    <main>
      <section className="hero-section">
        <div className="shell">
          <p className="hero-kicker">Rólunk</p>
          <h1>A SzemélyiKölcsön.com csapat</h1>
          <p className="hero-lead">
            Független pénzügyi összehasonlítással segítünk, hogy gyorsan,
            átláthatóan és magabiztosan választhasd ki a számodra legjobb
            banki terméket.
          </p>
        </div>
      </section>

      <section className="info-section">
        <div className="shell">
          <h2>Mit csinálunk?</h2>
          <p className="section-lead">
            Platformunk célja, hogy egy helyen lásd a legfontosabb hitel- és
            bankszámla lehetőségeket, és valós adatok alapján tudj dönteni.
          </p>
          <div className="info-grid">
            <article className="info-card">
              <h3>Összehasonlítás</h3>
              <p>
                Több pénzügyi konstrukciót mutatunk be egységes szerkezetben,
                hogy egyszerűen össze tudd vetni a feltételeket.
              </p>
            </article>
            <article className="info-card">
              <h3>Érthető tartalom</h3>
              <p>
                A bonyolult pénzügyi fogalmakat közérthetően foglaljuk össze,
                így nem maradsz egyedül a döntési helyzetekben.
              </p>
            </article>
            <article className="info-card">
              <h3>Online folyamat</h3>
              <p>
                A kalkulációtól az érdeklődés leadásáig minden gyorsan és
                kényelmesen, online elérhető.
              </p>
            </article>
          </div>
        </div>
      </section>

      <section className="info-section">
        <div className="shell">
          <h2>Miért érdemes minket választani?</h2>
          <div className="info-grid">
            <article className="info-card">
              <h3>Független szemlélet</h3>
              <p>
                A fókusz nálunk az igényeiden van: a célunk, hogy az élethelyzetedhez
                legjobban illeszkedő megoldást találd meg.
              </p>
            </article>
            <article className="info-card">
              <h3>Gyorsaság</h3>
              <p>
                Néhány perc alatt átláthatod a legfontosabb opciókat, így időt
                takarítasz meg a kutatással és döntéssel.
              </p>
            </article>
            <article className="info-card">
              <h3>Átláthatóság</h3>
              <p>
                Törekszünk arra, hogy a feltételek, költségek és következő lépések
                egyértelműek legyenek minden oldalon.
              </p>
            </article>
          </div>
        </div>
      </section>
    </main>
  );
}
